// Third-party imports
import React from 'react';
import { useRecordContext } from 'react-admin';
import { Box, Typography, Paper } from '@mui/material';

// Local imports - types
import type { RepairDetail, RepairTimelineEventType } from '@src/types';

const formatDate = (dateString: string | undefined) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString();
};

const TimelineDisplay = () => {
  const record = useRecordContext<RepairDetail>();

  if (!record || !record.timeline || record.timeline.length === 0) {
    return (
      <Box sx={{ padding: 2 }}>
        <Typography variant="body2">No timeline events available.</Typography>
      </Box>
    );
  }

  return (
    <Paper>
      <Box sx={{ padding: 2 }}>
        <Typography variant="h6" gutterBottom>Timeline</Typography>
        <Box sx={{ marginTop: 2 }}>
          {record.timeline.map((event: RepairTimelineEventType, index: number) => (
            <Box key={event.eventDate} sx={{ display: 'grid', gridTemplateColumns: '175px 1fr', gap: 1, mb: 2 }}>
              <Typography variant="body2">{formatDate(event.eventDate)}</Typography>
              <Typography variant="body2">{event.description || 'N/A'}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

export default TimelineDisplay;
